import { Mapper } from "../../../../base/utils/mapper";
import { FollowupResponseModel } from "../../../../domain/models/comercial/followup-response.model";
import { FollowupResponseEntity } from "../entities/followup-response.entity";

export class FollowupImplementationRepositoryMapper extends Mapper<FollowupResponseEntity, FollowupResponseModel> {
    mapFrom(param: FollowupResponseEntity): FollowupResponseModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: FollowupResponseModel): FollowupResponseEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}